import { render, staticRenderFns } from "./LensSpendBackOnboarding.vue?vue&type=template&id=9b5aaeea&scoped=true"
import script from "./LensSpendBackOnboarding.vue?vue&type=script&lang=js"
export * from "./LensSpendBackOnboarding.vue?vue&type=script&lang=js"
import style0 from "./LensSpendBackOnboarding.vue?vue&type=style&index=0&id=9b5aaeea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5aaeea",
  null
  
)

export default component.exports